import React from 'react';
import { useTranslation } from 'react-i18next';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Clickable, Sub, Table, TabButton, Tabs } from '../../performance-operations/styles';
import { DIMENSIONS, UNIT_ROWS, metricText } from '../config';

// Analiz §16 E13 — birim / yönetici ekibi kırılımı (ekip düzeyi; 1:1 yalnız sayı). Küçük hücre ve tamamlayıcısı gizlidir.
// Sıralama ada göredir: bir metriğe göre sıralı "yönetici listesi" üretilmez (analiz §33 — bileşik kalite sıralaması yok).
// Satır → o birim/ekip süzgeciyle sayfa (ortak süzgeç şeridine eklenir).
export default function UnitsPanel({ panel, dimension, onDimension, onPick }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const cells = (panel.data?.cells || []).slice(0, UNIT_ROWS);
  const more = (panel.data?.cells || []).length - cells.length;
  const oneOnOne = !!panel.data?.oneOnOneEnabled;
  const label = (c) => c.label || t('performance.feedbackAnalytics.unassigned');
  return (
    <PanelCard
      panelKey="units" title={t('performance.feedbackAnalytics.panel.units')} span={7}
      loading={panel.loading} error={panel.error} onRetry={panel.retry} empty={cells.length === 0}
    >
      <Tabs role="tablist">
        {DIMENSIONS.map((d) => (
          <TabButton key={d} $active={dimension === d} role="tab" aria-selected={dimension === d} onClick={() => onDimension?.(d)} data-tab={d}>
            {t(`performance.feedbackAnalytics.dimension.${d}`)}
          </TabButton>
        ))}
      </Tabs>
      <Table>
        <thead>
          <tr>
            <th>{t(`performance.feedbackAnalytics.dimension.${dimension}`)}</th>
            <th>{t('performance.feedbackAnalytics.col.people')}</th>
            <th>{t('performance.feedbackAnalytics.kpi.m39')}</th>
            <th>{t('performance.feedbackAnalytics.kpi.m40')}</th>
            <th>{t('performance.feedbackAnalytics.kpi.m41')}</th>
            {oneOnOne ? <th>{t('performance.feedbackAnalytics.kpi.m42')}</th> : null}
          </tr>
        </thead>
        <tbody>
          {cells.map((c) => (
            <tr key={c.key || 'none'} data-row={c.key || 'none'}>
              <td title={label(c)}>
                {c.key ? <Clickable onClick={() => onPick?.(dimension, c.key)}>{label(c)}</Clickable> : label(c)}
              </td>
              <td>{c.suppressed ? t('performance.feedbackAnalytics.suppressed') : c.eligibleN}</td>
              <td>{metricText(c.m39, t, lang)}</td>
              <td>{metricText(c.m40, t, lang)}</td>
              <td>{metricText(c.m41, t, lang)}</td>
              {oneOnOne ? <td>{metricText(c.m42, t, lang)}</td> : null}
            </tr>
          ))}
        </tbody>
      </Table>
      {more > 0 ? <Sub style={{ marginTop: 8 }}>{t('performance.feedbackAnalytics.moreUnits', { count: more })}</Sub> : null}
      <Sub style={{ marginTop: 8 }}>{t('performance.feedbackAnalytics.unitsNote')}</Sub>
    </PanelCard>
  );
}
